<div *ngIf="isReScheduleOrder || isConfirmedOrder">
  <div class="modal-header customBlueHeader">
    <p class="modal-title" *ngIf="isReScheduleOrder">Re-Scheduled & Confirm</p>
    <p class="modal-title" *ngIf="isConfirmedOrder">Confirm The Schedule Date</p>
    <!-- <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
        <span aria-hidden="true">&times;</span>
    </button> -->
    <button type="button" class="close" aria-label="Close" (click)="modelClose()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <!-- <div>{{msg}}</div> -->

  <div class="modal-body customModalBody">

    <div class="form-group" *ngIf="isReScheduleOrder">
      <label>Select Reason Type</label>
      <select class="form-control col-form-label-sm" [(ngModel)]="reasonType"
        (change)="getSubType($event.target.value)">
        <!-- <option>Select</option> -->
        <option [ngValue]="null" disabled>Select</option>
        <option *ngFor="let orderCancelType of orderCancelTypes" value={{orderCancelType.Id}}>
          {{orderCancelType.name}}

        </option>
      </select>
    </div>

    <div class="form-group" *ngIf="isReScheduleOrder">
      <label>Select Sub Reason Type</label>
      <select class="form-control col-form-label-sm" [(ngModel)]="subReasonType">
        <option>Select</option>
        <option *ngFor="let orderCancelSubType of orderCancelSubTypes" value={{orderCancelSubType.Id}}>
          {{orderCancelSubType.name}}

        </option>
      </select>
    </div>


    <div class="form-group">
      <label>Schedule Date & Time</label>
      <div class="input-group">
        <input class="form-control" [(ngModel)]="from_date" [minDate]="minDate" (dateSelect)="getDate($event)" placeholder="yyyy-mm-dd"
          name="dp" ngbDatepicker #fD="ngbDatepicker">
        <div class="input-group-append">
          <button class="btn btn-outline-secondary calendar" (click)="fD.toggle()" type="button"><i
              class="fa fa-calendar" aria-hidden="true"></i></button>
        </div>
      </div>

      <br />
      <select id="timeDropDown" [(ngModel)]="getSlotTimeInfo" (change)="timeSlotInfo(getSlotTimeInfo)" class="form-control col-form-label-sm">
        <option value="null">--Select--</option>
        <option  *ngFor="let slotRes of slotResponse" [value]="slotRes.from_time" >
          <!--{{slotRes.from_time}} - {{slotRes.to_time}}  class="dropdown-item active"-->
          {{slotRes.f_time}}
        </option>
      </select>

    </div>


    <div class="form-group" *ngIf="isReScheduleOrder">
      <label>Reason</label>
      <textarea class="form-control col-form-label-sm" [(ngModel)]="reason"></textarea>
    </div>

    <div class="alert alert-success text-center mrg-top-10" role="alert" *ngIf="isSuccessMsg">
    {{msg}}
    </div>
    <div class="alert alert-danger text-center mrg-top-10" role="alert" *ngIf="isFailureMsg">
      {{msg}}
    </div>

    <div class="modal-footer customModalFooter bdr-none" *ngIf="isConfirmedOrder">
      <button type="button" class="btn green_btn pull-right" (click)="modelClose()">Close</button>
      <button type="button" class="btn green_btn pull-right" (click)="submitModalData()">Confirm</button>
    </div>
    <div class="modal-footer customModalFooter bdr-none" *ngIf="isReScheduleOrder">
      <button type="button" class="btn green_btn pull-right" (click)="modelClose()">Close</button>
      <button type="button" class="btn green_btn pull-right" (click)="submitModalData()">Submit</button>
    </div>

  </div>
</div>


<div *ngIf="isReqReScheduleOrder || isReqCancelledOrder">
  <div class="modal-header customBlueHeader">
    <p class="modal-title" *ngIf="isReqReScheduleOrder">Request For Re-Scheduled</p>
    <p class="modal-title" *ngIf="isReqCancelledOrder">Request For Cancelled</p>

    <button type="button" class="close" aria-label="Close" (click)="modelClose()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <div class="modal-body customModalBody">

    <div class="form-group">
      <label>Select Reason Type</label>
      <select class="form-control col-form-label-sm" [(ngModel)]="reasonType"
        (change)="getSubType($event.target.value)">
        <!-- <option>Select</option> -->
        <option [ngValue]="null" disabled>Select</option>
        <option *ngFor="let orderCancelType of orderCancelTypes" value={{orderCancelType.Id}}>
          {{orderCancelType.name}}

        </option>
      </select>
    </div>

    <div class="form-group">
      <label>Select Sub Reason Type</label>
      <select class="form-control col-form-label-sm" [(ngModel)]="subReasonType">
        <option>Select</option>
        <option *ngFor="let orderCancelSubType of orderCancelSubTypes" value={{orderCancelSubType.Id}}>
          {{orderCancelSubType.name}}

        </option>
      </select>
    </div>


    <div class="form-group">
      <label>Reason</label>
      <textarea class="form-control col-form-label-sm" [(ngModel)]="reason"></textarea>
    </div>

    <div class="modal-footer customModalFooter bdr-none">
      <button type="button" class="btn green_btn pull-right" (click)="submitReqModal(isReqStatus)">Submit</button>
    </div>

  </div>
</div>

<div *ngIf="isCancelOrder">
  <div class="modal-header customBlueHeader">
    <p class="modal-title" *ngIf="isCancelOrder">Cancel Order</p>
    <button type="button" class="close" aria-label="Close" (click)="modelClose()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <div class="modal-body customModalBody">

    <div class="form-group">
      <label>Select Reason Type</label>
      <select class="form-control col-form-label-sm" [(ngModel)]="reasonType"
        (change)="getSubType($event.target.value)">
        <!-- <option>Select</option> -->
        <option [ngValue]="null" disabled>Select</option>
        <option *ngFor="let orderCancelType of orderCancelTypes" value={{orderCancelType.Id}}>
          {{orderCancelType.name}}

        </option>
      </select>
    </div>

    <div class="form-group">
      <label>Select Sub Reason Type</label>
      <select class="form-control col-form-label-sm" [(ngModel)]="subReasonType">
        <option>Select</option>
        <option *ngFor="let orderCancelSubType of orderCancelSubTypes" value={{orderCancelSubType.Id}}>
          {{orderCancelSubType.name}}

        </option>
      </select>
    </div>


    <div class="form-group">
      <label>Reason</label>
      <textarea class="form-control col-form-label-sm" [(ngModel)]="reason"></textarea>
    </div>

    <div class="form-group">
      <label>Refund Amount</label>
      <input type="number" class="form-control col-form-label-sm" 
      [(ngModel)]="amount" 
      [ngModelOptions]="{standalone: true}" 
     (ngModelChange)="validateAmount()" 
     [max]="maxAmount" 
      />
    </div>
    <div *ngIf="amount > maxAmount" class="text-danger">
      Refund amount must be equal to or less than {{ maxAmount }}.
    </div>
    <div class="modal-footer customModalFooter bdr-none">
      <button type="button" class="btn green_btn pull-right" (click)="submitCancelModal()">Submit</button>
    </div>

  </div>
  </div>

  <div *ngIf="isForceReschedule">
    <div class="modal-header customBlueHeader">
      <p class="modal-title">Re-Scheduled</p>
      <p class="modal-title" *ngIf="isConfirmedOrder">Confirm The Schedule Date</p>
      <!-- <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
          <span aria-hidden="true">&times;</span>
      </button> -->
      <button type="button" class="close" aria-label="Close" (click)="modelClose()">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
  
    <!-- <div>{{msg}}</div> -->
  
    <div class="modal-body customModalBody">  
      <div class="form-group">
        <label>Schedule Date</label>
        <div class="input-group">
          <input class="form-control" [(ngModel)]="from_date" [minDate]="minDate"  placeholder="yyyy-mm-dd"
            name="dp" ngbDatepicker #fD="ngbDatepicker">
          <div class="input-group-append">
            <button class="btn btn-outline-secondary calendar" (click)="fD.toggle()" type="button"><i
                class="fa fa-calendar" aria-hidden="true"></i></button>
          </div>
        </div>
      </div>
      <div class="form-group">
        <label>Schedule Time</label>
        <div class="input-group">
          <!-- <timepicker ></timepicker> -->
          <ngb-timepicker [(ngModel)]="time" [meridian]="meridian" ></ngb-timepicker>
          <!-- <input type="time" class="form-control input-md"name="" id="from_hour" value=""> -->
        </div>
      </div>
      <div class="form-group" >
        <label>Reason</label>
        <textarea class="form-control col-form-label-sm" [(ngModel)]="reason"></textarea>
      </div>
      
      <div class="modal-footer customModalFooter bdr-none">
        <button type="button" class="btn green_btn pull-right" (click)="modelClose()">Close</button>
        <button type="button" class="btn green_btn pull-right" (click)="forceReschedule()">Submit</button>
      </div>
    </div>
  </div>
